import Vue from "vue";
import {
  ValidationProvider,
  extend,
  ValidationObserver,
  configure,
} from "vee-validate";
import {
  required,
  image,
  size,
  max,
  min,
  email,
  integer,
} from "vee-validate/dist/rules";

const URL_REGEXPR =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/i;

const config = {
  mode: "lazy",
};
extend("required", {
  ...required,
  message: "Это обязательное поле",
});
extend("integer", {
  ...integer,
  message: "Укажите целочисленное значение",
});
extend("email", {
  ...email,
  message: "Укажите адрес электронной почты",
});
extend("image", {
  ...image,
  message() {
    return `Загруженный файл не является изображением`;
  },
});
extend("size", {
  ...size,
  message(fname, param) {
    return `Размер файла ${param._value_.name} не должен превышать ${
      param.size * 0.001
    } МБ`;
  },
});
extend("max", {
  ...max,
  message(fname, param) {
    return `Максимальное количество символов: ${param.length}`;
  },
});

extend("min", {
  ...min,
  message(fname, param) {
    return `Минимальное количество символов: ${param.length}`;
  },
});

extend("url", {
  validate(value) {
    return URL_REGEXPR.test(value);
  },
  message() {
    return "Неверный формат ссылки, укажите ссылку в формате http://domain.zone";
  },
});

extend("team_chat", {
  validate(value) {
    const strValue = String(value);
    return (
      strValue.startsWith("https://vk.me/") ||
      strValue.startsWith("https://t.me/")
    );
  },
  message() {
    return `Укажите ссылку-приглашение в чат Vk или Telegram`;
  },
});

// extend("team_chat", {
//   validate(value, param) {},
//   message(fname, param) {
//     return `Минимальное количество символов: ${param.length}`;
//   },
// });

// Sets the options.
configure(config);
// Register it globally
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
